module.exports = __webpack_public_path__ + "static/aragon-displays-600-a913b0acccae865a9fbb4a2728b80d85.png";